// Generado por scripts/write-version.mjs: no editar ni commitear.
export const version = {
  version: '1.0.10',
  builtAt: '2026-10-20T23:32:06.263Z',
};
